import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Stack, Tooltip } from '@mui/material';

interface Props {
  label: string;
  tooltip: string;
}

export default function InputLabelWithTooltip({ label, tooltip }: Props) {
  return (
    <Stack component="span" direction="row" alignItems="center" gap={0.5} sx={{ display: 'inline-flex' }}>
      {label}
      <Tooltip title={tooltip} describeChild>
        <Box
          component="span"
          tabIndex={0}
          role="img"
          aria-label={`About ${label.toLowerCase()}`}
          sx={{ display: 'inline-flex', pointerEvents: 'auto', cursor: 'help' }}
          onClick={(event) => event.preventDefault()}
        >
          <InfoOutlinedIcon fontSize="inherit" />
        </Box>
      </Tooltip>
    </Stack>
  );
}
